export default "__VITE_PUBLIC_ASSET__8baf63d2__"